export default "__VITE_ASSET__53db63d2__"